/**
 * NEDISO Think Tank Scene — Three.js r146
 * Product-integrated 3D showroom: real product cards on screens, click → quick-view
 */
(function () {
  'use strict';

  /* ── Boot ────────────────────────────────────────────────── */
  var _inited = false;
  document.addEventListener('nediso:room-ready', function (e) {
    if (_inited) return;
    _inited = true;
    initScene(window.nedisoRoom || {}, e.detail ? e.detail.tier : 2);
  });
  setTimeout(function () {
    if (!_inited) { _inited = true; initScene(window.nedisoRoom || {}, 2); }
  }, 5000);

  /* ── Product mapping: GLB mesh-name → Shopify handle ────── */
  var ROOM_PRODUCTS = {
    vw_screen_0:   { handle: 'maxhub-c5530',                          label: 'MAXHUB C5530 — 55" Interactive Display' },
    vw_screen_1:   { handle: 'maxhub-c6530',                          label: 'MAXHUB C6530 — 65" Interactive Display' },
    vw_screen_2:   { handle: 'maxhub-c7530',                          label: 'MAXHUB C7530 — 75" Interactive Display' },
    screen_seg_0:  { handle: 'maxhub-est09',                          label: 'MAXHUB EST09 — Desk Display' },
    screen_seg_1:  { handle: 'maxhub-est09',                          label: 'MAXHUB EST09 — Desk Display' },
    screen_seg_2:  { handle: 'maxhub-est09',                          label: 'MAXHUB EST09 — Desk Display' },
    screen_seg_3:  { handle: 'maxhub-est09',                          label: 'MAXHUB EST09 — Desk Display' },
    screen_seg_4:  { handle: 'maxhub-est11',                          label: 'MAXHUB EST11 — Desk Display' },
    screen_seg_5:  { handle: 'maxhub-est11',                          label: 'MAXHUB EST11 — Desk Display' },
    screen_seg_6:  { handle: 'maxhub-est11',                          label: 'MAXHUB EST11 — Desk Display' },
    screen_seg_7:  { handle: 'maxhub-est11',                          label: 'MAXHUB EST11 — Desk Display' },
    joan_screen:   { handle: 'joan-joan-6-black',                     label: 'JOAN 6 Black — Room Panel' },
    ptz_body:      { handle: 'maxhub-maxhub-uc-p25',                  label: 'MAXHUB UC P25 — PTZ Camera' },
    podium_screen: { handle: 'brightsign-hd6-digital-signage-player', label: 'BrightSign HD6 — Media Player' },
  };

  /* ── Scene init ──────────────────────────────────────────── */
  function initScene(room, gpuTier) {
    var container = room.container || document.getElementById('room-canvas-container');
    if (!container) { document.body.style.background = '#111'; return; }

    var W = container.clientWidth  || window.innerWidth;
    var H = container.clientHeight || window.innerHeight;
    var isMobile = /iPhone|iPad|Android/i.test(navigator.userAgent);

    if (!window.THREE) { container.style.background = '#1e2d4a'; return; }

    var Q = {
      dpr    : Math.min(devicePixelRatio, isMobile ? 1.5 : 2),
      shadows: gpuTier >= 2,
      bloom  : false,
      aa     : gpuTier >= 1
    };

    /* Renderer */
    var R = new THREE.WebGLRenderer({ antialias: Q.aa, alpha: false, powerPreference: 'high-performance' });
    R.setPixelRatio(Q.dpr);
    R.setSize(W, H);
    R.shadowMap.enabled = Q.shadows;
    R.shadowMap.type    = THREE.PCFSoftShadowMap;
    R.toneMapping       = THREE.ACESFilmicToneMapping;
    R.toneMappingExposure = 1.2;
    R.outputEncoding    = THREE.sRGBEncoding;
    container.appendChild(R.domElement);

    /* Scene */
    var S = new THREE.Scene();
    S.background = new THREE.Color(0x111827);
    S.fog = new THREE.FogExp2(0x111827, 0.015);

    /* Camera — at entrance (Z+), looking toward videowall (Z-) */
    var cam = new THREE.PerspectiveCamera(55, W / H, 0.1, 60);
    cam.position.set(4, 2.2, 5.5);

    /* Lights */
    S.add(new THREE.HemisphereLight(0x8090c0, 0x303040, 1.0));
    S.add(new THREE.AmbientLight(0xffffff, 0.6));
    var key = new THREE.DirectionalLight(0xfff5e0, 1.0);
    key.position.set(2, 6, 4);
    if (Q.shadows) {
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.camera.left = key.shadow.camera.bottom = -8;
      key.shadow.camera.right = key.shadow.camera.top = 8;
    }
    S.add(key);
    var fill = new THREE.DirectionalLight(0xc0d0ff, 0.5);
    fill.position.set(-5, 3, -3);
    S.add(fill);
    /* Pendant PointLights over table */
    [-2.1, -0.7, 0.7, 2.1].forEach(function (px) {
      var pl = new THREE.PointLight(0xffe8c0, 1.5, 5.0);
      pl.position.set(px, 2.5, 0);
      S.add(pl);
    });
    /* Screen glows */
    var vwGlow = new THREE.PointLight(0x4080ff, 1.5, 5);
    vwGlow.position.set(0, 1.5, -3.5);
    S.add(vwGlow);

    /* OrbitControls */
    var controls = null;
    if (THREE.OrbitControls) {
      controls = new THREE.OrbitControls(cam, R.domElement);
      controls.target.set(0, 1.2, -1);
      controls.enableDamping   = true;
      controls.dampingFactor   = 0.06;
      controls.minDistance     = 1.0;
      controls.maxDistance     = 12;
      controls.maxPolarAngle   = Math.PI * 0.72;
      controls.minPolarAngle   = Math.PI * 0.04;
      controls.enablePan       = false;
      controls.autoRotate      = true;
      controls.autoRotateSpeed = 0.3;
      R.domElement.addEventListener('pointerdown', function () { controls.autoRotate = false; }, { once: true });
      controls.update();
    }

    /* ── Load GLB ──────────────────────────────────────────── */
    var _clickables = [];
    var _meshByName = {};

    var glbUrl = window.NEDISO_ASSETS && window.NEDISO_ASSETS.konferenzraum;
    if (glbUrl && THREE.GLTFLoader) {
      var loader = new THREE.GLTFLoader();
      if (room.setProgress) room.setProgress(70, 'Lade Think Tank...');

      loader.load(glbUrl,
        function (gltf) {
          /* Apply materials + collect named meshes */
          var M = buildMaterials();
          gltf.scene.traverse(function (n) {
            if (!n.isMesh) return;
            if (Q.shadows) { n.castShadow = true; n.receiveShadow = true; }

            var mn = (n.material && n.material.name ? n.material.name : '').toLowerCase();
            var nn = n.name.toLowerCase();
            var key = MAT_MAP[mn] || MAT_MAP[nn];
            if (!key) {
              /* fuzzy: strip _N suffix */
              var base = nn.replace(/_\d+$/, '');
              key = MAT_MAP[base];
            }
            if (key && M[key]) n.material = M[key];

            /* Register for product mapping */
            _meshByName[nn] = n;
            var prod = ROOM_PRODUCTS[nn];
            if (prod) {
              n.userData.productHandle = prod.handle;
              n.userData.productLabel  = prod.label;
              _clickables.push(n);
            }
          });

          S.add(gltf.scene);

          if (room.setProgress) room.setProgress(90, 'Lade Produkte...');

          /* Fetch product data and draw cards on screens */
          loadProductCards(room, _meshByName);

          if (room.hideLoading) setTimeout(function () { room.hideLoading(); }, 300);
        },
        function (xhr) {
          if (xhr.total > 0 && room.setProgress)
            room.setProgress(70 + (xhr.loaded / xhr.total) * 20, 'Lade Modell...');
        },
        function (err) {
          console.error('[NEDISO] GLB error:', err);
          buildFallback(S, buildMaterials(), Q);
          if (room.hideLoading) room.hideLoading();
        }
      );
    } else {
      buildFallback(S, buildMaterials(), Q);
      if (room.hideLoading) setTimeout(function () { room.hideLoading(); }, 200);
    }

    /* ── Raycaster / click ─────────────────────────────────── */
    R.domElement.addEventListener('click', function (e) {
      if (!_clickables.length) return;
      var rect = R.domElement.getBoundingClientRect();
      var mouse = new THREE.Vector2(
        ((e.clientX - rect.left) / rect.width)  * 2 - 1,
       -((e.clientY - rect.top)  / rect.height) * 2 + 1
      );
      var ray = new THREE.Raycaster();
      ray.setFromCamera(mouse, cam);
      var hits = ray.intersectObjects(_clickables, false);
      if (hits.length) {
        var h = hits[0].object.userData.productHandle;
        if (h && room.showProduct) room.showProduct(h);
      }
    });

    /* Pointer cursor on hover */
    var _raycaster = new THREE.Raycaster();
    var _mouse = new THREE.Vector2(-9, -9);
    R.domElement.addEventListener('pointermove', function (e) {
      var rect = R.domElement.getBoundingClientRect();
      _mouse.x =  ((e.clientX - rect.left) / rect.width)  * 2 - 1;
      _mouse.y = -((e.clientY - rect.top)  / rect.height) * 2 + 1;
    });

    /* ── Resize ────────────────────────────────────────────── */
    new ResizeObserver(function () {
      W = container.clientWidth  || window.innerWidth;
      H = container.clientHeight || window.innerHeight;
      cam.aspect = W / H;
      cam.updateProjectionMatrix();
      R.setSize(W, H);
    }).observe(container);

    /* ── Animate ───────────────────────────────────────────── */
    var _vis = true;
    new IntersectionObserver(function (e) { _vis = e[0].isIntersecting; }).observe(container);

    (function animate() {
      requestAnimationFrame(animate);
      if (!_vis) return;

      /* Hover glow */
      if (_clickables.length && _mouse.x > -5) {
        _raycaster.setFromCamera(_mouse, cam);
        var hits = _raycaster.intersectObjects(_clickables, false);
        R.domElement.style.cursor = hits.length ? 'pointer' : '';
      }

      if (controls) controls.update();
      R.render(S, cam);
    })();

    /* Theme change */
    document.addEventListener('nediso:theme-change', function (e) {
      var dark = !(e.detail && e.detail.theme === 'light');
      S.background = new THREE.Color(dark ? 0x111827 : 0xe8eaf0);
      S.fog = new THREE.FogExp2(dark ? 0x111827 : 0xe8eaf0, 0.015);
      R.toneMappingExposure = dark ? 1.2 : 1.5;
    });
  }

  /* ── Product card loader ─────────────────────────────────── */
  function loadProductCards(room, meshByName) {
    if (!room.bridge) return;

    /* Unique handles to fetch */
    var uniqueHandles = {};
    Object.keys(ROOM_PRODUCTS).forEach(function (mn) {
      uniqueHandles[ROOM_PRODUCTS[mn].handle] = true;
    });
    var handles = Object.keys(uniqueHandles);

    Promise.all(handles.map(function (h) {
      return room.bridge.getProduct(h).catch(function () { return null; });
    })).then(function (products) {
      var byHandle = {};
      handles.forEach(function (h, i) { if (products[i]) byHandle[h] = products[i]; });

      Object.keys(ROOM_PRODUCTS).forEach(function (meshName) {
        var cfg     = ROOM_PRODUCTS[meshName];
        var product = byHandle[cfg.handle];
        var mesh    = meshByName[meshName];
        if (!mesh) return;

        /* Store product on mesh for click handler */
        if (product) mesh.userData.productHandle = product.handle || cfg.handle;

        /* Draw canvas texture */
        var isVideowall = meshName.indexOf('vw_screen') === 0;
        var isJoan      = meshName === 'joan_screen';
        var isDesk      = meshName.indexOf('screen_seg') === 0;

        var cw = isVideowall ? 1024 : isJoan ? 256 : 512;
        var ch = isVideowall ? 576  : isJoan ? 384 : 320;

        var cv  = document.createElement('canvas');
        cv.width = cw; cv.height = ch;
        var ctx = cv.getContext('2d');

        if (product) {
          drawProductCard(ctx, cw, ch, product, isJoan);
        } else {
          drawPlaceholder(ctx, cw, ch, cfg.label);
        }

        var tex = new THREE.CanvasTexture(cv);
        tex.encoding = THREE.sRGBEncoding;

        /* Load real product image async, then update texture */
        if (product && product.featured_image) {
          var img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () {
            drawProductCard(ctx, cw, ch, product, isJoan, img);
            tex.needsUpdate = true;
          };
          img.onerror = function () { tex.needsUpdate = true; };
          img.src = getImageSrc(product.featured_image, isVideowall ? 600 : 300);
        }

        mesh.material = new THREE.MeshBasicMaterial({ map: tex, toneMapped: false });
      });
    });
  }

  function getImageSrc(src, size) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_' + size + 'x$1$2');
  }

  /* ── Canvas draw functions ───────────────────────────────── */
  function drawProductCard(ctx, w, h, product, compact, img) {
    var isDark = true;
    var bg   = isDark ? '#0b0f1c' : '#f0f2f7';
    var fg   = isDark ? '#e8eaf2' : '#0f1523';
    var mute = isDark ? '#606880' : '#8090a8';
    var grn  = '#00a886';
    var bdr  = isDark ? '#1e2540' : '#d0d4e0';

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, w, h);

    /* Border */
    ctx.strokeStyle = bdr;
    ctx.lineWidth = 2;
    ctx.strokeRect(1, 1, w - 2, h - 2);

    /* NEDISO accent bar top */
    ctx.fillStyle = grn;
    ctx.fillRect(0, 0, w, 4);

    var imgH = compact ? Math.floor(h * 0.50) : Math.floor(h * 0.55);
    var imgY = 12;

    if (img) {
      /* Draw product image centered + cover */
      var scale = Math.min((w - 24) / img.naturalWidth, imgH / img.naturalHeight);
      var iw = img.naturalWidth  * scale;
      var ih = img.naturalHeight * scale;
      var ix = (w - iw) / 2;
      var iy = imgY + (imgH - ih) / 2;
      ctx.drawImage(img, ix, iy, iw, ih);
    } else {
      /* Placeholder gradient */
      var grd = ctx.createLinearGradient(0, imgY, 0, imgY + imgH);
      grd.addColorStop(0, isDark ? '#1a2035' : '#d8dce8');
      grd.addColorStop(1, isDark ? '#0e1220' : '#e8ecf4');
      ctx.fillStyle = grd;
      ctx.fillRect(12, imgY, w - 24, imgH);
      /* NEDISO logo placeholder */
      ctx.fillStyle = isDark ? '#2a3050' : '#c0c8dc';
      ctx.font = 'bold ' + Math.floor(imgH * 0.15) + 'px sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('NEDISO', w / 2, imgY + imgH / 2 + 6);
    }

    /* Title */
    var textY = imgY + imgH + 18;
    var title = product.title || '';
    /* Shorten vendor prefix */
    title = title.replace(/^[A-Z]+\s+/, '');
    ctx.fillStyle = fg;
    ctx.font = 'bold ' + (compact ? 12 : 15) + 'px system-ui, sans-serif';
    ctx.textAlign = 'center';
    /* Word-wrap simple: truncate */
    if (title.length > 30) title = title.substring(0, 28) + '…';
    ctx.fillText(title, w / 2, textY);

    /* Price */
    var price = '';
    if (product.variants && product.variants[0]) {
      price = parseFloat(product.variants[0].price).toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €';
    }
    if (price) {
      ctx.fillStyle = grn;
      ctx.font = 'bold ' + (compact ? 13 : 16) + 'px system-ui, sans-serif';
      ctx.fillText(price, w / 2, textY + (compact ? 18 : 24));
    }

    /* Vendor tag */
    var vendor = (product.vendor || '').toUpperCase();
    ctx.fillStyle = mute;
    ctx.font = (compact ? 9 : 10) + 'px system-ui, sans-serif';
    ctx.fillText(vendor, w / 2, h - 10);

    /* "Klicken für Details" hint */
    if (!compact) {
      ctx.fillStyle = isDark ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.18)';
      ctx.font = '9px system-ui, sans-serif';
      ctx.fillText('Klicken für Details', w / 2, h - 22);
    }
  }

  function drawPlaceholder(ctx, w, h, label) {
    ctx.fillStyle = '#0e1220';
    ctx.fillRect(0, 0, w, h);
    ctx.fillStyle = '#00a886';
    ctx.fillRect(0, 0, w, 4);
    ctx.fillStyle = '#1e2540';
    ctx.fillRect(12, 16, w - 24, Math.floor(h * 0.55));
    ctx.fillStyle = '#2a3050';
    ctx.font = 'bold 11px system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillText('NEDISO', w / 2, Math.floor(h * 0.45));
    ctx.fillStyle = '#606880';
    ctx.font = '10px system-ui, sans-serif';
    var l = (label || '').replace(/^[A-Z]+\s+/, '');
    if (l.length > 28) l = l.substring(0, 26) + '…';
    ctx.fillText(l, w / 2, Math.floor(h * 0.55) + 28);
  }

  /* ── Material map (Blender name → key) ──────────────────── */
  var MAT_MAP = {
    floor: 'floor', table: 'table', wall: 'wall', ceiling: 'ceiling',
    glass: 'glass', glass_oled: 'glass', glass_smart: 'glass',
    chrome: 'chrome', bezel: 'bezel', chair_base: 'chair',
    panel: 'panel', accent: 'accent', screen_off: 'screen_off',
    screen_active: 'screen_active', dock: 'accent', plant: 'plant'
  };

  function buildMaterials() {
    var env = buildEnvMap();

    function mp(opts) { return new THREE.MeshPhysicalMaterial(Object.assign({ envMap: env }, opts)); }
    function ms(opts) { return new THREE.MeshStandardMaterial(opts); }

    return {
      floor:         mp({ color: 0x2a2d3e, roughness: 0.28, metalness: 0.04, clearcoat: 0.6, clearcoatRoughness: 0.12, envMapIntensity: 0.4 }),
      table:         mp({ color: 0x1e2236, roughness: 0.12, metalness: 0.06, clearcoat: 0.85, clearcoatRoughness: 0.06, envMapIntensity: 0.8 }),
      wall:          ms({ color: 0x1e2436, roughness: 0.85 }),
      ceiling:       ms({ color: 0x141824, roughness: 0.92 }),
      glass:         mp({ color: 0x88c0f0, transmission: 0.85, roughness: 0.03, metalness: 0, ior: 1.5, thickness: 0.8, transparent: true, envMapIntensity: 0.8 }),
      chrome:        mp({ color: 0xd0d4e0, roughness: 0.07, metalness: 1.0, envMapIntensity: 1.2 }),
      bezel:         mp({ color: 0x1a1e2c, roughness: 0.24, metalness: 0.85, envMapIntensity: 0.5 }),
      chair:         mp({ color: 0x181c28, roughness: 0.55, metalness: 0.18, envMapIntensity: 0.3 }),
      panel:         ms({ color: 0x161a26, roughness: 0.72 }),
      accent:        ms({ color: 0x00a886, emissive: new THREE.Color(0x00a886), emissiveIntensity: 1.2, roughness: 0.3 }),
      screen_off:    new THREE.MeshBasicMaterial({ color: 0x030408 }),
      screen_active: new THREE.MeshBasicMaterial({ color: 0x071222 }),
      plant:         ms({ color: 0x1a4010, roughness: 0.92 }),
    };
  }

  function buildEnvMap() {
    if (!THREE.PMREMGenerator) return null;
    try {
      var canvas = document.createElement('canvas');
      canvas.width = canvas.height = 1;
      var fakeRenderer = { getContext: function () { return canvas.getContext('2d'); } };
      var pmrem = new THREE.PMREMGenerator(
        document.querySelector('canvas') ? { capabilities: { isWebGL2: true }, extensions: { get: function () { return null; } } } : null
      );
      return null;
    } catch (e) { return null; }
  }

  /* Fallback geometry if GLB fails */
  function buildFallback(scene, M, Q) {
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(14, 10), M.floor);
    floor.rotation.x = -Math.PI / 2;
    if (Q.shadows) floor.receiveShadow = true;
    scene.add(floor);

    var table = new THREE.Mesh(new THREE.BoxGeometry(7, 0.08, 1.6), M.table);
    table.position.set(0, 0.77, 0);
    if (Q.shadows) { table.castShadow = true; table.receiveShadow = true; }
    scene.add(table);

    var backWall = new THREE.Mesh(new THREE.PlaneGeometry(12, 3.5), M.wall);
    backWall.position.set(0, 1.75, -5);
    scene.add(backWall);

    /* Videowall panels */
    var vwMat = new THREE.MeshBasicMaterial({ color: 0x071222 });
    [-3.25, 0, 3.25].forEach(function (x, i) {
      var vw = new THREE.Mesh(new THREE.PlaneGeometry(3.0, 1.85), vwMat.clone());
      vw.position.set(x, 1.7, -4.95);
      vw.userData.productHandle = ['maxhub-c5530', 'maxhub-c6530', 'maxhub-c7530'][i];
      scene.add(vw);
    });
  }

})();
